import { useMutation, useQuery } from "@tanstack/react-query";
import { ShiftSchedulesAPI } from "../api";

export const useGetAllShiftSchedules = () => {
  return useMutation({
    mutationFn: () => ShiftSchedulesAPI.getAll(),
    onError: (error) => {
      console.error(
        "Get All Shift Schedules Failed: ",
        error.response || error
      );
    },
  });
};
export const _useGetAllShiftSchedules = ({
  page,
  pageSize,
  filterField1 = null,
  filterValue1 = null,
  filterField2 = null,
  filterValue2 = null,
}) => {
  return useQuery({
    queryKey: [
      "get-all-shift-schedules",
      page,
      pageSize,
      filterField1,
      filterValue1,
      filterField2,
      filterValue2,
    ],
    queryFn: () => {
      const obj = { page, pageSize };

      if (filterField1 && filterValue1) {
        obj.filterField1 = filterField1;
        obj.filterValue1 = filterValue1;
      }

      if (filterField2 && filterValue2) {
        obj.filterField2 = filterField2;
        obj.filterValue2 = filterValue2;
      }

      return ShiftSchedulesAPI.getAllPaginated(obj);
    },
    onError: (error) => {
      console.error(
        "Get All Shift Schedules Failed: ",
        error.response || error
      );
    },
  });
};
export const useCreateShift = () => {
  return useMutation({
    mutationFn: (payload) => ShiftSchedulesAPI.createShift(payload),
    onError: (error) => {
      console.error("Create Shift Failed: ", error.response || error);
    },
  });
};

export const useGetShiftById = (id) => {
  return useQuery({
    queryKey: ["get-shift-by-id", id],
    queryFn: () => ShiftSchedulesAPI.getById(id),
    enabled: !!id,
    onError: (error) => {
      console.error("Get Shift By ID Failed: ", error.response || error);
    },
  });
};

export const useUpdateShift = () => {
  return useMutation({
    mutationFn: ({ id, payload }) =>
      ShiftSchedulesAPI.updateShift({ id, payload }),
    onError: (error) => {
      console.error("Update Shift Failed: ", error.response || error);
    },
  });
};

export const useDeleteShift = () => {
  return useMutation({
    mutationFn: (id) => ShiftSchedulesAPI.deleteById(id),
    onError: (error) => {
      console.error("Delete Shift Failed: ", error.response || error);
    },
  });
};
